import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = (t) => ({ headers: { Authorization: `Bearer ${t}` } });

// public
export const subscribeNewsletter = (email) => axios.post(`${API}/newsletter`, { email });
export const registerInterest = (data) => axios.post(`${API}/register`, data);

// admin
export const adminLogin = (username, password) => axios.post(`${API}/admin/login`, { username, password });
export const getMe = (t) => axios.get(`${API}/admin/me`, auth(t));
export const getStats = (t) => axios.get(`${API}/admin/stats`, auth(t));
export const getNewsletter = (t, q = "") => axios.get(`${API}/admin/newsletter`, { ...auth(t), params: q ? { q } : {} });
export const getRegistrations = (t, q = "") => axios.get(`${API}/admin/registrations`, { ...auth(t), params: q ? { q } : {} });
export const setNewsletterStatus = (t, id, status) => axios.patch(`${API}/admin/newsletter/${id}`, { status }, auth(t));
export const setRegistrationStatus = (t, id, status) => axios.patch(`${API}/admin/registrations/${id}`, { status }, auth(t));
export const deleteNewsletter = (t, id) => axios.delete(`${API}/admin/newsletter/${id}`, auth(t));
export const deleteRegistration = (t, id) => axios.delete(`${API}/admin/registrations/${id}`, auth(t));
export const exportCsv = (t, kind) => axios.get(`${API}/admin/export/${kind}`, { ...auth(t), responseType: "blob" });
